<template>
    <div class="example clearfix">
        <router-link 
            v-for="v in getList" 
            :key="v.id" 
            :class="v.class" 
            :to="v.link"
        >
                <div class="example-style1-img">
                    <img :src="v.image">
                    <img class="front-img" :src="v.image">
                </div>
                <div class="example-style1-title">
                    {{v.title}}
                    <span class="R">{{v.date}}</span>
                </div>
                <div class="example-style-line"></div>
        </router-link>

        <div class="example-more_box"><router-link class="example-more" to="/example">更多</router-link></div>
    </div>
</template>
<script>

export default {
    name: 'Example',
    props: {
        exampleList: Array
    },
    data: function(){
        return {
            infor: {
                title: '案例' 
            },
           
        }
    },
    computed: {
        getList: function(){
            let list = [];
            list = this.exampleList.slice(0, 4);
            return list;
        }
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*@media*/
.example {
    position: relative;
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
}
.example-style1,
.example-style2 {
    position: relative;
    display: block;
    width: 39.16%;
    height: 270px;
    margin-bottom: 58px;
    font-size: 14px;
    border-bottom: 2px #333 solid;
    overflow: hidden;
}
.example-style2 {
    width: 56%;
}
.example-style1:hover,
.example-style2:hover {
    border-bottom-color: #FF764E;
    color:  #FF764E;
}
.example-style1-img,
.example-style2-img {
    position: absolute;
    height: 222px;
    width: auto;
    top: 0;
    left: 0;
    overflow: hidden;   
}
.example-style1-title,
.example-style2-title {
    position: absolute;
    width: 100%;
    bottom: 4px;
    left: 0;
}
.example-style1:hover .example-style-line,
.example-style2:hover .example-style-line {
    position: absolute;
    left: 0;
    top: 0;
    width: 12px;
    height: 222px;
    background-color:  #FF764E;
    z-index: 3;
}
.example-more_box {
    width: 100%;
    height: 0;
}
.example-more {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    bottom: 16px;
    right: 0;
    width: 65px;
    height: 30px;
    font-size: 14px;
    background-color: #333;
    color: #fff;
}
.example-more:hover {
    color: #333;
    font-weight: bold;
    background-color: #FF764E;
}
.front-img {
    position: absolute;
    width: auto;
    height: 100%;
    left: 0;
    top: 0;
    transform-origin: center;
    transform: scale(1,1);
    transition: all .2s linear;
}
.example-style1:hover .front-img,
.example-style2:hover .front-img {
    transform: scale(1.2);
}

@media screen and (min-width: 801px) and (max-width: 1200px) {
    .example {
        box-sizing: border-box;
        padding: 0 20px;
    }
    .example-style1:hover,
    .example-style2:hover {
        color: red;
    }
    .example-more {
        margin-right: 20px;
    }

}

@media screen and (max-width: 800px){

}

</style>